/**
 * Scrolls the container of an element in order to fully show the element. If the element is already fully visible it does nothing
 * @param elementToShow - The DOM element to fully show
 * @param container - The DOM element containing the element to show. The container should have vertical scroll enabled
 */
export default (elementToShow, container) => {
  const createValidationError = argName => new Error(`${argName} must be a valid DOM element`);
  const validateDomElement = element => element && element.getBoundingClientRect;

  if (!validateDomElement(elementToShow)) {
    throw createValidationError('elementToShow');
  }

  if (!validateDomElement(container)) {
    throw createValidationError('container');
  }

  const elementBottom = elementToShow.getBoundingClientRect().bottom;
  const containerBottom = container.getBoundingClientRect().bottom;

  const offsetToScroll = containerBottom < elementBottom ? elementBottom - containerBottom : 0;
  if (offsetToScroll > 0) {
    container.scrollTop += offsetToScroll;
  }
};
